import React, { ChangeEvent, Component } from "react";

import { IAnnotationField } from "@formant/core/model/IAnnotationField";
import { ITagParameters } from "@formant/core/model/ITagParameters";
import { ITags } from "@formant/core/model/ITags";
import { InputElement } from "@formant/ui/component/common/Field";

import { SelectField } from "../common/SelectField";

export interface IEditTagAnnotationFieldProps {
    field: IAnnotationField<"tag">;
    tags: ITags;
    onChange: (tags: ITags) => void;
    className?: string;
    invalid: boolean;
}

export class EditTagAnnotationField extends Component<IEditTagAnnotationFieldProps> {
    public render() {
        const { onChange } = this;
        const { field, tags, className, invalid } = this.props;
        const { key, parameters } = field;
        const value = tags[key];
        const options = (parameters as ITagParameters).choices;

        return (
            <div className={className}>
                <SelectField
                    label={field.name}
                    value={value || ""}
                    onChange={onChange}
                    invalid={invalid}
                    small={true}
                >
                    <option key="" value="" />
                    {options.map(_ => (
                        <option key={_} value={_}>
                            {_}
                        </option>
                    ))}
                </SelectField>
            </div>
        );
    }

    public labelFunction = (value: string | undefined) => {
        return value || "";
    };

    public onChange = (event: ChangeEvent<InputElement>): void => {
        const value = event.target.value;
        const { field, tags, onChange } = this.props;
        const { key } = field;
        if (value) {
            onChange({ ...tags, [key]: value });
        } else {
            const { [key]: _, ...rest } = tags;
            onChange(rest);
        }
    };
}
